export default __webpack_public_path__ + "static/media/autor-profile.cec89537.jpg";